import "./core-styles";
import './i18n/i18n'
import App from "./components/App/App";
import localStoragePolyfill from './LocalStoragePolyfill'

// For unsupported brosers, such as Safari Mobile on incognito mode
localStoragePolyfill()

export default App;
